import Vue from 'vue'
import VueResource from 'vue-resource'
import cookies from 'js-cookie'
import store from '../vuex/store'
import config from '../assets/js/config'

Vue.use(VueResource)
const publicResource = Vue.resource(config.serverAddr + '/public{/action}')

Vue.http.interceptors.push((request, next) => {
  Vue.http.headers.common['token'] = cookies.get('token') || ''
  store.state.showLoading = true
  next((response) => {
    store.state.showLoading = false
    if (!response.ok) {
      if (response.status === 401) {
        window.location = '/'
      } else {
        // 统一处理服务器异常！
        store.state.message = {
          message: '服务器异常，请稍后重试或联系管理员。',
          type: 'error'
        }
      }
    }
  })
})

export default {
  // 获取帮助中心的左边数据
  findHelpLeftList (opts) {
    return publicResource.query({action: 'findHelpLeftList', ...opts})
  },
  // 帮助中心id去获取根据数据
  getWconList (opts) {
    return publicResource.get({action: 'getWconList', ...opts})
  },
  getIndexWconList (opts) {
    return publicResource.get({action: 'getIndexWconList', ...opts})
  },
  getHomeClassifyList (opts) {
    return publicResource.get({action: 'getHomeClassifyList', ...opts})
  },
  // 文章id去获取根据数据
  getOperwconList (opts) {
    return publicResource.get({action: 'getOperwconList', ...opts})
  },
  getZbxxclassList (opts) {
    return publicResource.get({action: 'getZbxxclassList', ...opts})
  },
  getAreaList (opts) {
    return publicResource.get({action: 'getAreaList', ...opts})
  },
  getZbxxList (opts) {
    return publicResource.get({action: 'getZbxxList', ...opts})
  },
  getZbxxListById (opts) {
    return publicResource.get({action: 'findZbxxListById', ...opts})
  },
  getZbxxById (opts) {
    return publicResource.query({action: 'findZbxxById', ...opts})
  },
  findSwiperList (opts) {
    return publicResource.query({action: 'findSwiperList', ...opts})
  },
  // 文章列表list总数
  findOperWconCount (opts) {
    return publicResource.query({action: 'findOperWconCount', ...opts})
  },
  // 合作机构
  findCuList (opts) {
    return publicResource.query({action: 'findCuList', ...opts})
  },
  findOperMtId (opts) {
    return publicResource.query({action: 'findOperMtId', ...opts})
  },
  findOperMtName (opts) {
    return publicResource.query({action: 'findOperMtName', ...opts})
  },
  getSysparam () {
    return publicResource.query({action: 'getSysparam'})
  },
  getOperpopflg () {
    return publicResource.query({action: 'getOperpopflg'})
  },
  updateZbxxClick (opts) {
    return publicResource.query({action: 'updateZbxxClick', ...opts})
  },
  updateOperWconClick (opts) {
    return publicResource.query({action: 'updateWconClick', ...opts})
  }

}



// WEBPACK FOOTER //
// ./src/api/index.js